import {ReactComponent as Close} from 'src/assets/close.svg';
import React, {useState} from "react";
import { updatePostCardText} from "../../../api/index";

interface AlertProps {
    title: string;
    message: string;
    onClose: () => void;
    onConfirm: (editMsg: string) => void;
}

const PostCardTextModal: React.FC<AlertProps> = ({ title, message, onClose, onConfirm }) => {

    const [isEdit, setIsEdit] = useState(false);
    const [editMsg, setEditMsg] = useState<string>(message)


    const editText = () => {
        setIsEdit(true);
    }


    const handleConfirm = () => {
        if (onConfirm) {


            if(editMsg) {
                onConfirm(editMsg);
            }

        }
    };



    return (
        <>
            {/* 오버레이 */}
            <div className="overlay" />

            {/* 모달 */}
            <div className="penpal-alert flex flex-col w-full max-w-md p-6">
                {/* Header */}
                <div className="flex justify-between items-center pb-2 mb-2">
                    <h2 className="text-xl font-bold text-main">{title}</h2>
                    <button className="close-button" onClick={onClose}>
                        <Close/>
                    </button>
                </div>

                {/* contents */}

                <div className={"flex flex-col items-start gap-4 w-full"}>
                    <div className="flex flex-col gap-1">

                        <p className="text-[#8D8D8D] text-xs m-0 opacity-80">
                            독자들에게 엽서에 얽힌 소중한 순간이나 영감을 전해 주세요.
                        </p>
                    </div>

                    { isEdit ?
                        <div className="w-full relative">
                            <textarea
                                className="w-full h-40 leading-[1.6] bg-[#F8F9FA] border border-[#E9ECEF] rounded-2xl py-4 px-4 text-base focus:outline-main focus:bg-white transition-all resize-none"
                                value={editMsg}
                                onChange={(e) => setEditMsg(e.target.value)}
                                placeholder="엽서에 담긴 이야기를 들려주세요 (최대 200자)"
                                maxLength={200}
                            />
                            <div className="absolute bottom-3 right-4 text-xs text-[#ADB5BD]">
                                {editMsg?.length || 0}/200
                            </div>
                        </div>
                        :
                        <div className={`w-full min-h-[120px] leading-[1.6] bg-[#F1F3F5] rounded-2xl py-5 px-5 text-base text-[#495057] ${!message && 'italic text-[#ADB5BD] flex items-center justify-center'}`}>
                            {message || "아직 등록된 이야기가 없습니다. 수정 버튼을 눌러 이야기를 들려주세요!"}
                        </div>
                    }
                </div>

                {/* Footer */}
                <div className="flex flex-row gap-3 justify-center mt-8">
                    <button
                        className="bg-white border-main border-[1px] hover:bg-green-400 text-main px-7 py-2 rounded-3xl"
                        onClick={editText}
                    >
                    수정
                    </button>

                    <button
                        onClick={() => {
                            handleConfirm();
                            onClose();
                        }}
                        className="bg-main hover:bg-green-400 text-white px-7 py-2 rounded-3xl"
                    >
                        확인
                    </button>
                </div>
            </div>
        </>
    )
}

export default PostCardTextModal;
